import { observer } from 'owa-mobx-react';
import React from 'react';
import { getItemsOrConversationsSelectedText } from 'owa-mail-list-store';
import { isSingleLineListView } from 'owa-mail-layout';
import {
    getIsBitSet,
    type ListViewBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { getDensityModeCssClass } from 'owa-fabric-theme';
import { getMailboxInfoFromFolderId } from 'owa-mail-mailboxinfo/lib/getMailboxInfo';

import {
    customSelectionContainerNoSenderImage,
    customSelectionContainer,
} from './MailListHeaderSecondRow.scss';

import { mailListSecondRowCustomContainer, full, medium, compact } from '../MailListHeader.scss';

import classnames from 'owa-classnames';

export interface MailListHeaderSelectionRowContentProps {
    tableViewId: string;
    folderId: string;
}

const defaultExport: React.FunctionComponent<MailListHeaderSelectionRowContentProps> = observer(
    function MailListHeaderSelectionRowContent(props: MailListHeaderSelectionRowContentProps) {
        const mailboxInfo = getMailboxInfoFromFolderId(props.folderId);
        const isSingleLineView = isSingleLineListView();
        const isSenderImageOff = getIsBitSet(8, mailboxInfo);
        const isJunkMail = 'junkemail' === folderIdToName(props.folderId);
        const densityModeString = getDensityModeCssClass(full, medium, compact);
        const itemsOrConversationsText = getItemsOrConversationsSelectedText(props.tableViewId);
        return (
            <div
                className={classnames(mailListSecondRowCustomContainer, densityModeString)}
                role="heading"
                aria-level={2}
            >
                <span
                    className={
                        isSingleLineView && isSenderImageOff && !isJunkMail
                            ? customSelectionContainerNoSenderImage
                            : customSelectionContainer
                    }
                    title={itemsOrConversationsText}
                >
                    {itemsOrConversationsText}
                </span>
            </div>
        );
    },
    'MailListHeaderSelectionRowContent'
);
export default defaultExport;
